import { render, staticRenderFns } from "./PressRussian.vue?vue&type=template&id=956215f0&scoped=true&"
import script from "./PressRussian.vue?vue&type=script&lang=js&"
export * from "./PressRussian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956215f0",
  null
  
)

export default component.exports